<template>
<div class="stripReport">
    <div class="myChart" id="myChartStrip" style="'width:100%;height:300px"></div>
</div>
</template>

<script>
import echarts from 'echarts'
export default {
    name: 'stripReport',
    props: ['stripDatas'],
    mounted() {
        this.drawLine()
    },
    methods: {
        drawLine() {
            var myChart = echarts.init(document.getElementById('myChartStrip'))
            var option = {
                color: ['#1890FF'],
                title: {
                    text: this.stripDatas.title,
                    subtext: this.stripDatas.subText
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01]
                },
                xAxis: {
                    type: 'category',
                    data: this.stripDatas.listX
                },
                series: [
                    {
                        name: '用户访问量',
                        type: 'bar',
                        barWidth: 50,
                        data: this.stripDatas.listY
                    }
                ]
            }

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option)
        }
    },
    watch: {
        stripDatas: {
            handler: function () {
                this.drawLine()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.stripReport{

}
</style>
